module.exports = __webpack_public_path__ + "img/13.7cacabd9.jpg";